import { parsePhoneNumberFromString, CountryCode } from "libphonenumber-js"

const AU_PHONE_REGEX = /^(\+?61|0)[\s-]*[23478]([\s-]*\d){8}$/

const DEFAULT_PHONE_REGEX = /^([+]{0,1})([0-9- ]+)$/

export function mustBeValidPhoneNumber(
  value = "",
  country: CountryCode = "GB"
): string | undefined {
  const phoneRegex = country === "AU" ? AU_PHONE_REGEX : DEFAULT_PHONE_REGEX

  const defaultValue = value === null ? "" : value.toString()
  const phoneNumber = parsePhoneNumberFromString(defaultValue, country)

  if (phoneNumber && phoneRegex.test(value)) {
    if (
      phoneNumber.isValid() ||
      (phoneNumber.isPossible() && phoneNumber?.country?.trim() === country)
    ) {
      return undefined
    } else {
      return `Please enter a valid phone number`
    }
  } else {
    const countryLabel =
      country === "GB" ? "UK" : country === "AU" ? "Australian" : country
    return `Please enter a valid ${countryLabel} phone number`
  }
}
